module.exports = __webpack_public_path__ + "static/media/mtwo.05357437.png";